module.exports = __webpack_public_path__ + "img/artthebee.e4cc9aba.jpg";